import { render, staticRenderFns } from "./creacion.vue?vue&type=template&id=7b2b866e&"
import script from "./creacion.vue?vue&type=script&lang=ts&"
export * from "./creacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports